import styled from 'styled-components';

export const Anchor = styled.a`
  text-decoration: none;
  cursor: pointer;
`;
